<template>
  <modal
    name="about-online-modal"
    align="center"
  >
    <div class="base-modal__heading base-modal__item">
      <h3 class="base-modal__title" v-html="$t('aboutOnlineModal.title')"></h3>
    </div>
    <div class="base-modal__body base-modal__item">
      <div class="steps-text text-left">
        <div class="steps-text__item">
          <div class="text-lg mb-8"><b v-html="$t('aboutOnlineModal.step1Title')"></b></div>
          <div class="color-black-85" v-html="$t('aboutOnlineModal.step1Text')"></div>
        </div>
        <div class="steps-text__item">
          <div class="text-lg mb-8"><b v-html="$t('aboutOnlineModal.step2Title')"></b></div>
          <div class="color-black-85" v-html="$t('aboutOnlineModal.step2Text', trackersMarkup)">
          </div>
        </div>
        <div class="steps-text__item">
          <div class="text-lg mb-8"><b v-html="$t('aboutOnlineModal.step3Title')"></b></div>
          <div class="color-black-85" v-html="$t('aboutOnlineModal.step3Text')"></div>
        </div>
        <div class="steps-text__item">
          <div class="text-lg mb-8"><b v-html="$t('aboutOnlineModal.step4Title')"></b></div>
          <div class="color-black-85" v-html="$t('aboutOnlineModal.step4Text')"></div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'AboutOnlineModal',
  components: {
    Modal,
  },
  data() {
    return {
      trackers: [
        { name: 'Garmin', href: 'https://connect.garmin.com/' },
        { name: 'Polar', href: 'https://www.polar.com/ru/beat' },
        { name: 'Suunto', href: 'https://www.suunto.com/ru-ru/suunto-app/suunto-app/' },
      ],
    };
  },
  computed: {
    trackersMarkup() {
      const trackers = this.trackers.map((o) => (
        `<a class="link" href="${o.href}" target="_blank">${o.name}</a>`
      ));
      return [
        trackers.slice(0, -1).join(', '),
        trackers[trackers.length - 1],
      ];
    },
  },
};
</script>
